import React from "react";
import { Row, Col, Card } from "antd";
import Strings from "../../utils/Strings";

const DeviceHeader = () => {
  return (
    <Card bodyStyle={styles.card}>
      <Row gutter={8}>
        <Col span={3}>
          <span style={styles.headerText}>{Strings.inventoryId}</span>
        </Col>
        <Col span={4}>
          <div style={styles.headerText}>{Strings.projectName}</div>
        </Col>
        <Col span={2}>
          <span style={styles.headerText}>{Strings.inventoryType}</span>
        </Col>
        <Col span={3}>
          <span style={styles.headerText}>{Strings.inventoryOS}</span>
        </Col>
        <Col span={3}>
          <div style={styles.headerText}>{Strings.companyName}</div>
        </Col>

        <Col span={3}>
          <span style={styles.headerText}>{Strings.purchaseDate}</span>
        </Col>
        <Col span={3}>
          <div style={styles.headerText}>{Strings.purchaseType}</div>
        </Col>
      </Row>
    </Card>
  );
};
export default DeviceHeader;

const styles = {
  headerText: {
    fontSize: 16,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "noWrap"
  },
  card: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 20
  }
};
